module.exports = __webpack_public_path__ + "static/squaretwo-94b1c46beb13a394112896f8ce2f5510.jpg";